<template>
    <div class="w-full h-full align-center justify-center p-2 mt-2">
        <div class="flex flex-row gap-3 mb-1">
            <VLSkeleton width="30%" height="2rem" class="mb-2" />
            <VLSkeleton width="20%" height="2rem" class="mb-5" />
        </div>

        <div class="skeleton-header flex mt-10 pb-8 justify-between">
            <VLSkeleton v-for="i in 4" :key="i" width="20%" height="30px" />
        </div>

        <div v-for="i in 6" :key="i" class="skeleton-row flex p-2 mb-2 mr-2 justify-between">
            <VLSkeleton v-for="j in 4" :key="j" width="18%" height="1.2rem" />
        </div>
    </div>
</template>

<style scoped>

.skeleton-header {
    border-bottom: 1px solid #ddd;
}

.skeleton-row {
    border-bottom: 1px solid #ddd;
}
</style>
